import { render, staticRenderFns } from "./LiveMatchTrackerAmerican.vue?vue&type=template&id=57db9ca3&scoped=true"
import script from "./LiveMatchTrackerAmerican.vue?vue&type=script&lang=js"
export * from "./LiveMatchTrackerAmerican.vue?vue&type=script&lang=js"
import style0 from "./LiveMatchTrackerAmerican.vue?vue&type=style&index=0&id=57db9ca3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db9ca3",
  null
  
)

export default component.exports